import homeGraphic from "assets/images/HomeGraphic.png";
import * as Constant from "utilities/Constant";
import { getPreferredLanguage, hasExplicitUserLanguageSelection, isSpanishLanguage } from "utilities/getPreferredLanguage";

const formatContent = (content: string[]) => (
  <ul className="registration-list">
    {content.map((line) => (
      <li key={line}>{line}</li>
    ))}
  </ul>
);

const getGraphicClassName = (): string =>
  hasExplicitUserLanguageSelection() && isSpanishLanguage(getPreferredLanguage())
    ? "registration__graphic registration__graphic--spanish"
    : "registration__graphic";

export function RegistrationInformationPanel() {
  return (
    <>
      <p className="registration__text1">Better Path to Homeownership</p>
      <p className="registration__text2">Seamless, Secure, and Built for You</p>
      <p className="registration__text3">{formatContent(Constant.registrationInformation)}</p>
      <img src={homeGraphic} alt="login-graphic" className={getGraphicClassName()} />
    </>
  );
}

interface RegistrationDesktopInformationProps {
  readonly isDesktop: boolean;
}

export function RegistrationDesktopInformation({ isDesktop }: RegistrationDesktopInformationProps) {
  if (!isDesktop) {
    return null;
  }

  return (
    <div className="registration__information">
      <RegistrationInformationPanel />
    </div>
  );
}
